import React, { useState } from "react";
import Container from "../../General/Container/Container";
import PersonasOtherInfoGroup from "./PersonasOtherInfoGroup";

const PersonasOtherInfo = ({
    style = {},
    loading,
    data,
    classColor,
    forPrint
}) => {
    const toPrintStyle = forPrint ? { width: "calc(50% - 1rem)" } : { width: "calc(25% - 2rem)" }
    const renderGroup = (title) => {
        const itemCount = Object.values(data?.[title] || {}).reduce((sum, arr) => {
            sum += arr.length
            return sum
        }, 0)
        if (!itemCount) return null

        return <PersonasOtherInfoGroup
            loading={loading}
            title={title}
            data={data}
            classColor={classColor}
            style={toPrintStyle}
            forPrint={forPrint}
        />
    }
    return <Container className={`${forPrint ? "dwrap" : "drow"} gap-2 download-personas`} style={style}>
        {renderGroup("Psychographics")}
        {renderGroup("Behavioral Factors")}
        {renderGroup("Challenges")}
        {renderGroup("Values")}
    </Container>
}

export default PersonasOtherInfo